
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ContactHero />
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
